import { render, staticRenderFns } from "./DeclineExtension.vue?vue&type=template&id=4cb8d4ea&"
import script from "./DeclineExtension.vue?vue&type=script&lang=js&"
export * from "./DeclineExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports